import Validator from 'validatorjs'
import { VALIDATION_ERRORS }
  from 'LiveBoard/components/shared/CallToAction/types/forms/constants'

const SHARE_VALIDATIONS = {
  rules: {
    email: 'required|email'
  }
}

export function validate(values) {
  const validator = new Validator(
    values,
    SHARE_VALIDATIONS.rules,
    VALIDATION_ERRORS
  )

  validator.passes()
  return validator.errors.all()
}
